"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteGlobalConfig = deleteGlobalConfig;
exports.globalConfigPage = globalConfigPage;
exports.saveGlobalConfig = saveGlobalConfig;
exports.updateGlobalConfig = updateGlobalConfig;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
// 分页查询全局配置
function globalConfigPage(query) {
  return (0, _requestPIM.default)({
    url: "/xyGlobalConfig/page",
    method: "get",
    params: query
  });
}

// 新增全局配置
function saveGlobalConfig(data) {
  return (0, _requestPIM.default)({
    url: '/xyGlobalConfig',
    method: 'post',
    data: data
  });
}

// 更新全局配置
function updateGlobalConfig(data) {
  return (0, _requestPIM.default)({
    url: '/xyGlobalConfig',
    method: 'put',
    data: data
  });
}

// 删除全局配置
function deleteGlobalConfig(id) {
  return (0, _requestPIM.default)({
    url: '/xyGlobalConfig',
    method: 'delete',
    params: {
      id: id
    }
  });
}